import { useQuery } from "@tanstack/react-query";
import { getAdminSettings } from "@/lib/api";
import { unscopedKey } from "@/lib/queryClient";
import { AuditCard, AuthProvidersCard, EmailCard } from "./system-cards";

/**
 * Super-admin system settings (multi-club).
 *
 * Platform-wide infrastructure that is shared across every club — email /
 * Brevo delivery, Google/Apple OAuth provider credentials, and the platform
 * settings audit trail. These are super-admin only (the backend endpoints
 * are gated by require_super_admin, apex/admin host only), distinct from a
 * club's own branding/flags which a club admin edits at /admin/settings
 * (→ /api/club/settings).
 *
 * The cards live in ./system-cards (they were cut from the club admin
 * console when these endpoints became super-admin only).
 */
export function SystemSettingsPage() {
  // Same queryKey the club SettingsPage uses for this payload so the two
  // never hold divergent copies while both exist during the transition.
  const settingsQuery = useQuery({
    queryKey: unscopedKey("admin-settings"),
    queryFn: getAdminSettings,
  });

  return (
    <div data-testid="super-admin-system" className="flex flex-col gap-4">
      <div className="flex flex-col">
        <h2 className="font-display text-base text-ink">System Settings</h2>
        <p className="text-xs text-ink-muted">
          Platform-wide infrastructure shared by every club — email delivery and
          social sign-in credentials. Per-club branding lives in each club’s own
          admin console.
        </p>
      </div>
      <EmailCard />
      <AuthProvidersCard />
      <AuditCard audit={settingsQuery.data?.audit ?? []} />
    </div>
  );
}
